module.exports = __webpack_public_path__ + "static/img/product8.4eb4ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product8.png
// module id = bJ+k
// module chunks = 13